import intl from "react-intl-universal";

const STATUS_STYLES = {
  active: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  blocked: "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400",
  pending: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  suspended: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400",
  deactivated: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400",
};

export const BaasAccountStatusBadge = ({ status }) => {
  const labelKey = `baas.accounts.status.${status}`;
  const label = intl.get(labelKey) || status;

  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
        STATUS_STYLES[status] ?? STATUS_STYLES.pending
      }`}
    >
      {label}
    </span>
  );
};
